import { FC, UIEventHandler, CSSProperties } from 'react';
import ReactScrollbarsCustom from 'react-scrollbars-custom';
import { ScrollState } from 'react-scrollbars-custom/dist/types/types';

export type ScrollBlockProps = {
  style: CSSProperties & {
    height: string;
    width?: string;
  };
  onScroll?: (options: { bottomOffset: number }) => void;
};

export const ScrollBlock: FC<ScrollBlockProps> = ({
  children,
  onScroll,
  ...props
}) => {
  const handleScroll = (scrollValues: ScrollState, _: ScrollState) => {
    const bottomOffset =
      scrollValues.contentScrollHeight -
      (scrollValues.scrollTop + scrollValues.clientHeight);

    onScroll && onScroll({ bottomOffset });
  };

  return (
    <ReactScrollbarsCustom
      onScroll={
        handleScroll as UIEventHandler<HTMLDivElement> &
          ((scrollValues: ScrollState, prevScrollState: ScrollState) => void)
      }
      {...props}
      wrapperProps={{
        renderer: ({ elementRef, ...restProps }) => (
          <div
            {...restProps}
            ref={elementRef}
            className={`scrollbarsWrapper ${
              restProps.style?.right === 0 && `paddingRightZero`
            }`}
          />
        ),
      }}
      thumbYProps={{
        renderer: ({ elementRef, ...restProps }) => (
          <div {...restProps} ref={elementRef} className="tHuMbY" />
        ),
      }}
      trackYProps={{
        renderer: ({ elementRef, ...restProps }) => (
          <div {...restProps} ref={elementRef} className="trackY" />
        ),
      }}
    >
      {children}
    </ReactScrollbarsCustom>
  );
};
